import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

/** An async report job (PRD §3.9). Created PENDING; a worker flips it to RUNNING then COMPLETED/FAILED. */
export interface EdReportJob {
  jobId: string;
  type: string;
  format: string;
  status: EdReportJobStatus;
  downloadUrl: string;
  requestedAt: string;
  errorMessage?: string | null;
}

export type EdReportType = 'portfolio' | 'transactions' | 'settlement' | 'exposure';
export type EdReportFormat = 'pdf' | 'xlsx' | 'csv';
export type EdReportJobStatus = 'PENDING' | 'RUNNING' | 'COMPLETED' | 'FAILED';

/**
 * DI token for the E-D Reports API (PRD §3.9, EM-838). Bound to `EdReportsRestService`.
 * Reports run as true background jobs: request → poll `getJob` until terminal → `downloadJob`.
 * E-D-scoped server-side (Rule 22). REST-only (Rules 07/10).
 */
export interface EdReportsApi {
  /** POST /services/embedded/api/v1/ed/reports/{type}?format= — creates a PENDING job */
  requestReport(type: EdReportType, format: EdReportFormat): Observable<EdReportJob>;
  /** GET /services/embedded/api/v1/ed/reports/jobs/{jobId} — poll status */
  getJob(jobId: string): Observable<EdReportJob>;
  /** GET /services/embedded/api/v1/ed/reports/jobs/{jobId}/download — returns a Blob (409 until ready) */
  downloadJob(jobId: string): Observable<Blob>;
}

export const ED_REPORTS = new InjectionToken<EdReportsApi>('ED_REPORTS');
